import axios from "axios";
import { ThreadMessageSearchAPIResultModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import { IAPIResult } from "models/interfaces";

export async function search(thread_id: string) {
  const response = await axios.post<
    IAPIResult<ThreadMessageSearchAPIResultModel>
  >("/api.d/v1/ec/thread-message/search", { thread_id });
  return response.data;
}

export async function create(
  thread_id: string,
  message: string,
  // message_append_file_list: {
  //   message_append_file_name: string;
  //   message_append_file: string;
  // }[]
  message_append_file_list: CommonFileModel[]
) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/thread-message/create",
    {
      thread_id,
      message,
      message_append_file_list,
    }
  );
  return response.data;
}

export async function download(message_id: string, seq_no: number) {
  const response = await axios.post<BlobPart>(
    "/api.d/v1/ec/thread-message/file-download",
    { message_id, seq_no },
    { responseType: "blob" }
  );
  return response;
}
